export const hasValue = (value, obj) => Object.values(obj).includes(value);